@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.profileForm {
  padding-top: 10px;
  padding-bottom: 15px;

  .avatar {
    img {
      border-radius: 50%;
      height: 85px;
      width: 85px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .formRow {
    align-items: center;
    display: flex;
  }

  .avatarUpload {
    width: 85px;
    height: 85px;
  }

  .icon {
    @include inter-medium;
    font-size: 20px;
    margin-top: -1px;
  }

  .hide {
    display: none;
  }

  .defaultAvatar {
    margin-top: 32px;

    img {
      border-radius: 50%;
      height: 42px;
      width: 42px;
    }
  }

  .nameInput {
    @include md-sohne;
    @include input-border;
    border-radius: 8px;
    padding: 12px;
    width: 100%;
    margin-left: 12px;
  }
}
